<template>
  <div>
    <router-view v-if="showNestedChildRoute"></router-view>
    <div v-if="!haveNestedChildRoute && initialized">
      <CRow class="justify-content-between mb-3">
        <CCol sm="auto"
          ><div class="ui-type-display-lg">
            {{ $t("family.market.list.title") }}
          </div>
          <CRow class="mt-2">
            <CCol sm="auto">
              <p>
                {{ $t("family.market.list.description") }}
              </p></CCol
            >
          </CRow>
        </CCol>
        <CCol sm="4" class="mr-3">
          <!-- 
          <CRow
            class="flex-row justify-content-end align-items-center mt-0 mb-0"
          >
            <CButtonGroup>
              <CInput
                class="flex-row justify-content-end mb-0"
                horizontal
                placeholder="Market ID"
              />
              <CButton class="mb-3" color="primary" type="submit">
                <font-awesome-icon icon="plus" />
              </CButton>
            </CButtonGroup>
          </CRow>
          <CRow class="flex-row justify-content-end align-items-center mt-0">
            <span class="mr-2">Show all markets</span>
            <CSwitch variant="3d" size="sm" color="primary" />
          </CRow>
          -->
        </CCol>
      </CRow>

      <div class="loading text-center" v-if="loading">
        <CSpinner color="primary" size="lg" />
      </div>
      <div v-else>
        <div
          id="tourMarkets"
          class="masonry-container"
          v-if="markets.length > 0"
        >
          <div v-for="market in markets" :key="market.id" class="masonry-item">
            <MarketBoxNew :market="market" />
          </div>
        </div>
        <CAlert color="primary" v-else class="text-muted d-inline-block">
          <font-awesome-icon icon="exclamation-triangle" class="mr-2" />
          {{ $t("family.market.list.noMarkets") }}
        </CAlert>

        <CRow v-if="markets.length > 0">
          <CCol>
            <Pagination
              v-if="numPages > 1"
              :data="pagination"
              @paginate="getMarkets"
              :maxVisiblePages="7"
            />
          </CCol>
          <CCol
            xs="12"
            sm="12"
            md="12"
            lg="12"
            class="
              ml-auto
              d-flex
              flex-row
              justify-content-end
              align-items-center
            "
          >
            {{ $t("common.pagination.itemSelect") }}
            <UiSelect
              :value.sync="queryFilters.limit.term"
              :options="[1, 5, 10]"
              custom
              class="m-0 ml-2"
            />
          </CCol>
        </CRow>
      </div>
    </div>
  </div>
</template>

<script>
import MarketBoxNew from "./partials/MarketBoxNew.vue";
import { mapGetters } from "vuex";
import { apiGetRQL } from "../../helpers/apiHelper";
import Pagination from "../../common/table/Pagination.vue";
import UiSelect from "../../common/form/UiSelect";

export default {
  name: "UiMarkets",
  components: {
    MarketBoxNew,
    Pagination,
    UiSelect,
  },

  data() {
    return {
      initialized: false,
      loading: false,
      markets: [],
      numPages: 1,
      currentPage: 1,
      queryFilters: {
        limit: {
          style: "query",
          operator: "=",
          term: parseInt(localStorage.getItem("l_market_rows")) || 5,
        },
        offset: {
          style: "query",
          operator: "=",
          term: 0,
        },
      },
      pagination: {
        count: 0,
        next: null,
        previous: null,
        limit: parseInt(localStorage.getItem("l_market_rows")) || 5,
      },
    };
  },

  computed: {
    showNestedChild() {
      const { marketId } = this.$route.params;
      return marketId && !isNaN(parseInt(marketId, 10));
    },

    haveNestedChildRoute() {
      const { marketId } = this.$route.params;
      return marketId && !isNaN(parseInt(marketId, 10));
    },

    showNestedChildRoute() {
      const { marketId } = this.$route.params;
      return marketId && !isNaN(parseInt(marketId, 10)) && this.initialized;
    },

    ...mapGetters("connections", ["familyId"]),
  },

  mounted() {
    this.initialized = true;
    this.getMarkets();
  },

  watch: {
    currentPage: function () {
      this.getMarkets();
    },
  },

  methods: {
    async getMarkets(page = null) {
      this.loading = true;

      let filter = this.queryFilters;

      if (page) {
        filter.offset = {
          style: "query",
          operator: "=",
          term: (page - 1) * this.queryFilters.limit.term,
        };
      }

      filter.limit = {
        style: "query",
        operator: "=",
        term: this.queryFilters.limit.term,
      };

      let params = {
        endpoint: "family_markets",
        params: this.familyId,
        filter: filter,
      };

      const response = await apiGetRQL(params);

      if (response && response.data) {
        this.numPages = Math.ceil(
          response.data.payload.Count / this.queryFilters.limit.term
        );
        this.markets = response.data.payload.Items.filter(
          (market) => market.market.mtype !== 2
        );
        this.pagination = {
          count: response.data.payload.Count,
          limit: parseInt(filter.limit.term),
          offset: parseInt(filter.offset.term),
        };
        this.loading = false;
      }
    },
  },
  watch: {
    "queryFilters.limit.term": async function (newVal, oldVal) {
      localStorage.setItem("l_market_rows", parseInt(newVal));
      this.pagination.limit = parseInt(newVal);
      await this.getMarkets();
    },
  },
};
</script>
